import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// Higher resolution map data
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json";

// EU Member States (27 countries as of 2024)
const EU_COUNTRIES = [
    { code: "040", name: "Austria" },
    { code: "056", name: "Belgium" },
    { code: "100", name: "Bulgaria" },
    { code: "191", name: "Croatia" },
    { code: "196", name: "Cyprus" },
    { code: "203", name: "Czech Republic" },
    { code: "208", name: "Denmark" },
    { code: "233", name: "Estonia" },
    { code: "246", name: "Finland" },
    { code: "250", name: "France" },
    { code: "276", name: "Germany" },
    { code: "300", name: "Greece" },
    { code: "348", name: "Hungary" },
    { code: "372", name: "Ireland" },
    { code: "380", name: "Italy" },
    { code: "428", name: "Latvia" },
    { code: "440", name: "Lithuania" },
    { code: "442", name: "Luxembourg" },
    { code: "470", name: "Malta" },
    { code: "528", name: "Netherlands" },
    { code: "616", name: "Poland" },
    { code: "620", name: "Portugal" },
    { code: "642", name: "Romania" },
    { code: "703", name: "Slovakia" },
    { code: "705", name: "Slovenia" },
    { code: "724", name: "Spain" },
    { code: "752", name: "Sweden" }
].sort((a, b) => a.name.localeCompare(b.name));

const EU_CODES = EU_COUNTRIES.map(c => c.code);

const EUMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 550,
                center: [15, 54]
            }}
            width={800}
            height={700}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => EU_CODES.includes(geo.id))
                        .map((geo) => {
                            const countryCode = geo.id;
                            const isVisited = visited.includes(countryCode);

                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(countryCode)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="eu"
            analyticsLocationType="eu_country"
            trackingLabel="EU Map"
            storageKey="eu_map"
            title="🇪🇺 European Union Travel Map"
            subtitle="Click on EU member states you've visited, or use the checklist below!"
            items={EU_COUNTRIES.map(c => ({ id: c.code, name: c.name }))}
            noun="Countries"
            unitLabel="countries"
            captionUnit="EU countries"
            share={{
                region: 'EU',
                fileName: 'visited-eu-map.png',
                trackId: 'eu'
            }}
            renderMap={renderMap}
        />
    );
};

export default EUMapSection;
